export class UndoRedoBusyError extends Error {
  constructor() {
    super("Wait for undo or redo to finish, then try again");
  }
}

export function undoRedoErrorMessage(error: unknown, fallback: string) {
  return error instanceof UndoRedoBusyError ? error.message : fallback;
}
